const CustomerContactTypes = [
    { name: "Standard", value: "STANDARD" },
    { name: "Emergency", value: "EMERGENCY" },
    { name: "Alternative Pickup", value: "ALTERNATIVE_PICKUP" },
];

export default CustomerContactTypes;
